// ブラウザを切り替えるコンポーネント.
import { detect } from 'detect-browser';
import { User } from '../../../constants/UserListField';
import { ResponseData } from '../../../constants/HomeVisit';
import React, { FC } from 'react';
import Chrome from './Chrome';
import InternetExplorer from './InternetExplorer';
import Edge from './Edge';
import Safari from './Safari';
import Default from './Default';
import Mobile from './Mobile';

import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// 居宅訪問チェックシート.
interface BrowserHandlerProps {
  user: User;
  homeVisit: ResponseData;
}

const BrowserHandler: FC<BrowserHandlerProps> = ({ user, homeVisit }) => {
  const theme = useTheme();
  const matches = {
    xs: useMediaQuery(theme.breakpoints.down('xs')),
    sm: useMediaQuery(theme.breakpoints.down('sm')),
  };
  const isMediaPrint = window.matchMedia('print');

  if (!isMediaPrint.matches && (matches.xs || matches.sm)) {
    return <Mobile user={user} homeVisit={homeVisit} />;
  }

  const browser = detect();
  if (browser) {
    const name: string = browser.name;
    switch (name) {
      case 'ie':
        return <InternetExplorer user={user} homeVisit={homeVisit} />;
      case 'chrome':
        return <Chrome user={user} homeVisit={homeVisit} />;
      case 'safari':
        return <Safari user={user} homeVisit={homeVisit} />;
      case 'edge':
        return <Edge user={user} homeVisit={homeVisit} />;
      default:
        return <Default user={user} homeVisit={homeVisit} />;
    }
  }

  // 安全策.
  return <Default user={user} homeVisit={homeVisit} />;
};

export default BrowserHandler;
